/**
 * M.2 — NIPE tool: getSkill
 *
 * Read-only. Fetches the full SKILL.md body for one Skill by name.
 * F1 added live skillVersions fetch when the portal has a Skill row.
 */

import type { NipeTool } from './types';

export interface GetSkillContext {
  getSkill: (name: string) => Promise<{ name: string; body: string } | null>;
}

export const getSkillTool: NipeTool<GetSkillContext> = {
  schema: {
    type: 'function',
    function: {
      name: 'getSkill',
      description: 'Fetch the full SKILL.md body for one Skill by name.',
      parameters: {
        type: 'object',
        properties: {
          name: {
            type: 'string',
            description: 'Skill name (matches frontmatter `name` field).',
          },
        },
        required: ['name'],
      },
    },
  },
  mutatesRemote: false,
  requiresApproval: false,
  handler: async (args, ctx) => {
    const skillName = typeof args.name === 'string' ? args.name : '';
    if (!skillName) return { error: 'name required' };
    const skill = await ctx.getSkill(skillName);
    if (!skill) return { error: `Skill "${skillName}" not found` };
    return skill;
  },
};
